import { render, staticRenderFns } from "./ImagPreview.vue?vue&type=template&id=06e1fb74&scoped=true"
import script from "./ImagPreview.vue?vue&type=script&lang=js"
export * from "./ImagPreview.vue?vue&type=script&lang=js"
import style0 from "./ImagPreview.vue?vue&type=style&index=0&id=06e1fb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1fb74",
  null
  
)

export default component.exports